<template>
  <v-container fluid fill-height>
    <v-img id="background"></v-img>
    <v-row align="center" justify="center">
      <v-card id="vcard" outlined class="elevation-15">
        <v-card-title class="justify-center">
          <img
            width="80"
            src="@/assets/logo_sta.svg"
            alt="Some textual description of image"
          />
          <!-- <p class="font-weight-light" style="font-size: small">
              Verify from Sri Trang Group
            </p> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-col align="center" justify="center">
            <sweetalert-icon icon="success" :key="replay"> </sweetalert-icon>
            <p class="text-loading-color text-msg">{{ msg }}</p>
          </v-col></v-card-text
        >
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    replay: 1,
    msg: "",
  }),
  mounted() {
    this.msg = this.$route.query.msg;
  },
  methods: {
    countDownTimer() {
      if (this.replay > 0) {
        setTimeout(() => {
          this.replay += 1;
          this.countDownTimer();
        }, 3000);
      }
    },
  },
  created() {
    this.countDownTimer();
  },
};
</script>
<style scoped>
#vcard {
  max-width: 350px;
  width: 100%;
  background-color: white;
  filter: blur(0px) !important;
}
#background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("../assets/background.svg") no-repeat center center fixed !important;
  background-size: cover;
  align-items: center;
  justify-items: center;
  filter: blur(3px);
}
.text-msg {
  font-size: large;
}
</style>
